import { connect } from 'react-redux'

const mapStateToProps = (state) => {
    return {
        seatsInfoData: state?.pages?.hall?.movie?.seatsInfoData?.seatsEntries,
        priceCategories: state?.pages?.hall?.seating?.data?.prices,
    }
}

const hocConnect = (InnerComponent) => connect(mapStateToProps, {})(InnerComponent)

export default hocConnect
